import { render, staticRenderFns } from "./CustomConfigForm.vue?vue&type=template&id=3264746c&scoped=true"
import script from "./CustomConfigForm.vue?vue&type=script&lang=js"
export * from "./CustomConfigForm.vue?vue&type=script&lang=js"
import style0 from "./CustomConfigForm.vue?vue&type=style&index=0&id=3264746c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3264746c",
  null
  
)

export default component.exports